import { Grid, Typography, styled } from "@mui/material";

export const DateDescriptionContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "center",
  gap: "5px",
});

export const InfoContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

export const DescriptionText = styled(Typography)({
  fontWeight: "bold",
  display: "-webkit-box",
  WebkitLineClamp: "2",
  overflow: "hidden",
  WebkitBoxOrient: "vertical",
  textOverflow: "ellipsis",
});
